export class ImageCropper {

    static getRotationAngles(sides, newPolygonX, newPolygonY, newPolygonRadius, newPolygonRotation) {

        Math.toRadians = (angle) => { return angle * (Math.PI / 180); }
        Math.toDegrees = (angle) => { return angle * (180 / Math.PI); }

        // Calculate how many degrees the hexagon should be rotated (int number of 30 degrees => sticky to nearest side or point)
        const degreesPerSide = 360 / sides;
        const degreesPerPolyPos = degreesPerSide / 2;
        let polygonQuotient = Math.round(newPolygonRotation / degreesPerPolyPos)
        const stickyPolygonRotation = polygonQuotient * degreesPerPolyPos
        const stickyImageRotation = - newPolygonRotation + (polygonQuotient % 2 === 0 ? 0 : degreesPerPolyPos)
        // End calculation of rotations

        return { stickyPolygonRotation, stickyImageRotation }
    }

    static createCroppedImageUrl(sourceImage, noOfSidesInPolygon, newPolygonX, newPolygonY, newPolygonRadius, newPolygonRotation, drawPolygonFunction, onCroppedDataUrl) {

        Math.toRadians = (angle) => { return angle * (Math.PI / 180); }

        let cropCanvas = document.createElement("canvas")
        let cropCtx = cropCanvas.getContext("2d")

        const propsImage = sourceImage
        let cropImage = new Image()
        cropImage.src = propsImage.src
        cropImage.onload = () => {
                
            cropCanvas.width = 2 * newPolygonRadius
            cropCanvas.height = 2 * newPolygonRadius

            const { stickyPolygonRotation, stickyImageRotation } = this.getRotationAngles(noOfSidesInPolygon, newPolygonX, newPolygonY, newPolygonRadius, newPolygonRotation)

            const polygonRotation = Math.toRadians(stickyPolygonRotation)
            const startX = newPolygonRadius *      Math.sin(polygonRotation) // Because canvas 0 is at PI/2 and angle increment is clockwise
            const startY = -1 * newPolygonRadius * Math.cos(polygonRotation) // Because canvas 0 is at PI/2 and angle increment is clockwise

            let x = newPolygonRadius + startX
            let y = newPolygonRadius + startY

            cropCtx.save()
            cropCtx.beginPath()
            cropCtx.moveTo(x, y) // top point

            let minX = cropCanvas.width
            let minY = cropCanvas.height
            let maxX = 0
            let maxY = 0

            if(x < minX) minX = x
            if(y < minY) minY = y
            if(x > maxX) maxX = x
            if(y > maxY) maxY = y

            for (let n = 1; n < noOfSidesInPolygon; n++) {
                x = newPolygonRadius * Math.sin(polygonRotation + ( n * 2 * Math.PI / noOfSidesInPolygon))
                y = -1 * newPolygonRadius * Math.cos(polygonRotation + ( n * 2 * Math.PI / noOfSidesInPolygon))

                x += newPolygonRadius
                y += newPolygonRadius

                if(x < minX) minX = x
                if(y < minY) minY = y
                if(x > maxX) maxX = x
                if(y > maxY) maxY = y

                cropCtx.lineTo(x, y)
            }
            cropCtx.closePath()
            cropCtx.clip()

            const sx = newPolygonX - newPolygonRadius
            const sy = newPolygonY - newPolygonRadius
            const sWidth = 2 * newPolygonRadius
            const sHeight = 2 * newPolygonRadius
            const dx = -cropCanvas.width / 2
            const dy = -cropCanvas.height / 2
            const dWidth = 2 * newPolygonRadius
            const dHeight = 2 * newPolygonRadius

            cropCtx.save()
            cropCtx.translate(cropCanvas.width / 2, cropCanvas.height / 2)
            cropCtx.rotate(Math.toRadians(stickyImageRotation))
            cropCtx.drawImage(cropImage, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)

            let croppedDataUrl = cropCanvas.toDataURL()
            //onCroppedDataUrl(croppedDataUrl)

            // crop final image to smallest possible rectangular size
            let finalCropCanvas = document.createElement("canvas")
            finalCropCanvas.width = maxX - minX
            finalCropCanvas.height = maxY - minY
            let finalCropCtx = finalCropCanvas.getContext("2d")
            let finalCropImage = new Image()
            finalCropImage.src = croppedDataUrl
            finalCropImage.onload = () => {
                finalCropCtx.drawImage(finalCropImage, minX, minY, finalCropCanvas.width, finalCropCanvas.height, 
                                        0, 0, finalCropCanvas.width, finalCropCanvas.height)
                const croppedDataUrl2 = finalCropCanvas.toDataURL("image/png", 1.0)
                onCroppedDataUrl(croppedDataUrl2)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/lib/imageCropper.js